(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-list"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript?.closest('.menu-page') || document.querySelector('.menu-page');
  if (!root) return;

  const catTabs   = root.querySelectorAll('.cat-tab');
  const pillNavs  = root.querySelectorAll('.sub-pills');
  const grids     = root.querySelectorAll('.dish-grid');
  const FLAT      = ['SHISHA','DESSERTS'];

  function setActiveGrid(cat, sub){
    // Fade-out current
    const current = root.querySelector('.dish-grid.is-active');
    const targetSelector = FLAT.includes(cat)
      ? `.dish-grid[data-cat="${cat}"]`
      : `.dish-grid[data-cat="${cat}"][data-sub="${cat === 'FOOD' ? sub : sub}"]`;
    const target = root.querySelector(targetSelector);

    if (!target) return;
    if (current === target) return;

    if (current){
      current.classList.add('is-fading');
      setTimeout(() => {
        current.classList.remove('is-active','is-fading');
        target.classList.add('is-active');
        target.style.opacity = '0';
        // force reflow
        void target.offsetWidth;
        target.style.opacity = '';
      }, 150);
    } else {
      target.classList.add('is-active');
    }
  }

  function selectCategory(cat){
    catTabs.forEach(t => {
      const active = t.dataset.cat === cat;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', String(active));
    });

    // Toggle pill rows
    pillNavs.forEach(nav => {
      const matches = nav.dataset.group === cat;
      nav.hidden = !matches;
    });

    // Toggle flat-category state class so CSS can restore tab→grid spacing
    root.classList.toggle('is-flat-category', FLAT.includes(cat));

    if (FLAT.includes(cat)){
      setActiveGrid(cat, '_');
    } else {
      // Reset active pill to the first one in the matching nav
      const activeNav = root.querySelector(`.sub-pills[data-group="${cat}"]`);
      if (activeNav){
        const firstPill = activeNav.querySelector('.sub-pill');
        activeNav.querySelectorAll('.sub-pill').forEach(p => p.classList.remove('is-active'));
        firstPill?.classList.add('is-active');
        setActiveGrid(cat, firstPill?.dataset.sub);
      }
    }
  }

  catTabs.forEach(tab => tab.addEventListener('click', () => selectCategory(tab.dataset.cat)));

  pillNavs.forEach(nav => {
    nav.addEventListener('click', (e) => {
      const pill = e.target.closest('.sub-pill');
      if (!pill) return;
      const cat = nav.dataset.group;
      const sub = pill.dataset.sub;
      nav.querySelectorAll('.sub-pill').forEach(p => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      setActiveGrid(cat, sub);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-bundles"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.TerraceOrder) return;
  const rail = document.querySelector('[data-order-cart-rail]');
  if (!rail) return;
  const count = rail.querySelector('[data-cart-count]');
  const meta  = rail.querySelector('[data-cart-meta]');
  const list  = rail.querySelector('[data-cart-list]');
  const total = rail.querySelector('[data-cart-total]');
  const co    = rail.querySelector('[data-cart-checkout]');
  window.TerraceOrder.onChange(()=>{
    const items = window.TerraceOrder.items();
    const n = window.TerraceOrder.count();
    count.textContent = n + ' item' + (n===1?'':'s');
    total.textContent = window.TerraceOrder.totalFormatted();
    list.innerHTML = '';
    if (items.length === 0){
      meta.style.display = 'block';
      co.setAttribute('aria-disabled','true');
    } else {
      meta.style.display = 'none';
      co.removeAttribute('aria-disabled');
      items.forEach((it, idx)=>{
        const li = document.createElement('li');
        li.innerHTML = `<span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis">
                          ${it.product_title}${it.quantity>1?` <span class="qty">× ${it.quantity}</span>`:''}
                        </span>
                        <span class="tnum">${window.TerraceOrder.format(it.line_price)}</span>
                        <button class="x" aria-label="Remove">×</button>`;
        li.querySelector('.x').addEventListener('click', ()=>window.TerraceOrder.change(idx+1, 0));
        list.appendChild(li);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-byo"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript?.closest('.order-byo-section') || document.querySelector('.order-byo-section');
  if (!root) return;
  const byoEl = root.querySelector('.byo');
  if (!byoEl) return;
  let step = 1;
  const sel = { base:null, protein:null, mezze:new Set(), drink:null };

  function total(){
    let t = 0;
    ['base','protein','drink'].forEach(g=>{
      if (sel[g]){
        const btn = byoEl.querySelector(`.byo__opts[data-group="${g}"] .byo__opt[data-name="${cssEscape(sel[g])}"]`);
        if (btn) t += parseFloat(btn.dataset.delta || 0);
      }
    });
    sel.mezze.forEach(n=>{
      const btn = byoEl.querySelector(`.byo__opts[data-group="mezze"] .byo__opt[data-name="${cssEscape(n)}"]`);
      if (btn) t += parseFloat(btn.dataset.delta || 0);
    });
    return t;
  }
  function cssEscape(s){ return (window.CSS?.escape?.(s)) || s.replace(/"/g,'\\"'); }
  function updatePrice(){
    byoEl.querySelector('[data-byo-price]').textContent = '$' + total().toFixed(2);
  }
  function show(n){
    step = Math.max(1, Math.min(4, n));
    byoEl.querySelectorAll('.byo__step').forEach(s=>{
      s.hidden = Number(s.dataset.step) !== step;
    });
    byoEl.querySelectorAll('[data-dot]').forEach(d=>{
      const i = Number(d.dataset.dot);
      d.classList.toggle('on', i===step);
      d.classList.toggle('done', i<step);
    });
    byoEl.querySelector('[data-byo-back]').disabled = step===1;
    byoEl.querySelector('[data-byo-next]').textContent = step===4 ? 'Add to Cart →' : 'Next →';
  }

  byoEl.querySelectorAll('.byo__opt').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const group = btn.closest('.byo__opts').dataset.group;
      const multi = btn.closest('.byo__opts').dataset.multi === 'true';
      const name = btn.dataset.name;
      if (multi){
        if (sel[group].has(name)){ sel[group].delete(name); btn.classList.remove('on'); }
        else { sel[group].add(name); btn.classList.add('on'); }
      } else {
        sel[group] = name;
        btn.parentElement.querySelectorAll('.byo__opt').forEach(b=>b.classList.remove('on'));
        btn.classList.add('on');
      }
      updatePrice();
    });
  });

  byoEl.querySelector('[data-byo-back]').addEventListener('click', ()=>show(step-1));
  byoEl.querySelector('[data-byo-next]').addEventListener('click', ()=>{
    if (step < 4){ show(step+1); return; }
    const proteins = sel.protein || 'Custom';
    const base = sel.base || 'Rice';
    const mezzeList = sel.mezze.size ? ` + ${[...sel.mezze].join(', ')}` : '';
    const drink = sel.drink && sel.drink !== '(skip)' ? ` + ${sel.drink}` : '';
    const name = `${proteins} over ${base}${mezzeList}${drink}`;
    const price = total();
    if (price <= 0) return;
    window.TerraceOrder?.add(name, price);
    // reset
    sel.base = null; sel.protein = null; sel.mezze.clear(); sel.drink = null;
    byoEl.querySelectorAll('.byo__opt.on').forEach(o=>o.classList.remove('on'));
    updatePrice();
    show(1);
  });

  show(1);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  const hero = document.querySelector('.order-hero');
  if (!hero) return;

  /* ---------- Slideshow ---------- */
  const slides = hero.querySelectorAll('.order-hero__slide');
  if (slides.length > 1){
    const interval = Math.max(2, Number(hero.dataset.autoplay) || 4) * 1000;
    let i = 0;
    setInterval(()=>{
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, interval);
  }

  /* ---------- Pickup / Delivery toggle ---------- */
  const card    = hero.querySelector('.order-hero__card');
  const segBtns = hero.querySelectorAll('.order-hero__seg button');
  const pickupInfo = hero.querySelector('[data-pickup-info]');
  const deliveryInput = hero.querySelector('[data-delivery-input]');

  function setMode(mode){
    card.dataset.mode = mode;
    segBtns.forEach(b => b.classList.toggle('on', b.dataset.mode === mode));
    pickupInfo.hidden  = mode !== 'pickup';
    deliveryInput.hidden = mode !== 'delivery';
  }
  segBtns.forEach(b => b.addEventListener('click', ()=>setMode(b.dataset.mode)));

  /* ---------- Date options ---------- */
  const dateSel = hero.querySelector('#order-hero-date');
  const daysAhead = Math.max(1, Number(hero.dataset.days) || 14);
  const today = new Date();
  today.setHours(0,0,0,0);
  function pad(n){ return String(n).padStart(2,'0'); }
  function isoDate(d){ return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`; }
  function mmdd(d){ return `${pad(d.getMonth()+1)}/${pad(d.getDate())}`; }
  const dayNames = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  for (let i = 0; i < daysAhead; i++){
    const d = new Date(today); d.setDate(today.getDate() + i);
    const opt = document.createElement('option');
    opt.value = isoDate(d);
    let label;
    if (i === 0) label = `Today · ${mmdd(d)}`;
    else if (i === 1) label = `Tomorrow · ${mmdd(d)}`;
    else label = `${dayNames[d.getDay()]} · ${mmdd(d)}`;
    opt.textContent = label;
    dateSel.appendChild(opt);
  }

  /* ---------- Time options ---------- */
  const timeSel = hero.querySelector('#order-hero-time');
  const opening = (hero.dataset.opening || '11:00').split(':').map(Number);
  const closing = (hero.dataset.closing || '23:45').split(':').map(Number);
  const step    = Number(hero.dataset.step || 15);
  const lead    = Number(hero.dataset.lead || 30);

  function fmt12(h, m){
    const period = h >= 12 ? 'PM' : 'AM';
    const hh = ((h + 11) % 12) + 1;
    return `${hh}:${pad(m)} ${period}`;
  }
  function key24(h, m){ return `${pad(h)}:${pad(m)}`; }

  function rebuildTimes(){
    const selectedDate = dateSel.value;
    const isToday = selectedDate === isoDate(today);
    const now = new Date();
    const cutoffMin = isToday ? (now.getHours()*60 + now.getMinutes() + lead) : -1;

    const startMin = opening[0]*60 + opening[1];
    const endMin   = closing[0]*60 + closing[1];

    const prev = timeSel.value;
    timeSel.innerHTML = '';

    let firstAvailable = null;
    for (let mins = startMin; mins <= endMin; mins += step){
      if (mins < cutoffMin) continue;
      const h = Math.floor(mins/60), m = mins % 60;
      const opt = document.createElement('option');
      opt.value = key24(h, m);
      opt.textContent = fmt12(h, m);
      timeSel.appendChild(opt);
      if (firstAvailable === null) firstAvailable = opt.value;
    }
    if (!timeSel.children.length){
      const opt = document.createElement('option');
      opt.value = '';
      opt.textContent = 'Closed today — pick another date';
      timeSel.appendChild(opt);
    } else if ([...timeSel.options].some(o => o.value === prev)) {
      timeSel.value = prev;
    } else if (firstAvailable) {
      timeSel.value = firstAvailable;
    }
  }
  dateSel.addEventListener('change', rebuildTimes);
  rebuildTimes();

  /* ---------- Persistence + Cart attributes ---------- */
  const input = document.getElementById('order-hero-addr');
  try {
    const saved = JSON.parse(sessionStorage.getItem('terrace_order') || '{}');
    if (saved.mode) setMode(saved.mode);
    if (saved.address && input) input.value = saved.address;
    if (saved.date && [...dateSel.options].some(o => o.value === saved.date)) {
      dateSel.value = saved.date;
      rebuildTimes();
    }
    if (saved.time && [...timeSel.options].some(o => o.value === saved.time)) {
      timeSel.value = saved.time;
    }
  } catch(e) {}

  function pushAttributes(){
    const mode = card.dataset.mode || 'pickup';
    const dateVal = dateSel.value;
    const timeVal = timeSel.value;
    if (!dateVal || !timeVal) return Promise.resolve();

    const dateOpt = dateSel.options[dateSel.selectedIndex];
    const timeOpt = timeSel.options[timeSel.selectedIndex];

    const attrs = {
      'Fulfillment': mode === 'pickup' ? 'Pickup' : 'Delivery',
      'Requested Date': dateOpt ? dateOpt.textContent : dateVal,
      'Requested Time': timeOpt ? timeOpt.textContent : timeVal,
      'Requested Date (ISO)': dateVal,
      'Requested Time (24h)': timeVal
    };
    if (mode === 'delivery'){
      attrs['Delivery Address'] = (input?.value || '').trim();
      attrs['Pickup Address'] = '';
    } else {
      attrs['Pickup Address'] = (hero.querySelector('[data-address]')?.textContent || '').trim();
      attrs['Delivery Address'] = '';
    }

    // expose to other scripts for use during add-to-cart
    window.TerraceFulfillment = attrs;

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(()=>window.TerraceOrder?.refresh?.());
  }

  // expose so add-to-cart can hydrate before the first add
  window.TerracePushFulfillment = pushAttributes;
  // hydrate window.TerraceFulfillment on load so add-to-cart can include attrs
  (function hydrate(){
    const mode = card.dataset.mode || 'pickup';
    const dateOpt = dateSel.options[dateSel.selectedIndex];
    const timeOpt = timeSel.options[timeSel.selectedIndex];
    window.TerraceFulfillment = {
      'Fulfillment': mode === 'pickup' ? 'Pickup' : 'Delivery',
      'Requested Date': dateOpt ? dateOpt.textContent : '',
      'Requested Time': timeOpt ? timeOpt.textContent : '',
      'Requested Date (ISO)': dateSel.value,
      'Requested Time (24h)': timeSel.value,
      'Pickup Address': mode === 'pickup' ? (hero.querySelector('[data-address]')?.textContent || '').trim() : '',
      'Delivery Address': mode === 'delivery' ? (input?.value || '').trim() : ''
    };
  })();

  /* ---------- Delivery validation (Mapbox) ---------- */
  const modal      = hero.querySelector('[data-modal]');
  const modalAddr  = hero.querySelector('[data-modal-address-text]');
  const modalMap   = hero.querySelector('[data-modal-map]');
  const mbToken    = modal.dataset.mapboxToken;
  const storeLat   = parseFloat(modal.dataset.storeLat) || 51.0447;
  const storeLng   = parseFloat(modal.dataset.storeLng) || -114.0719;
  const radiusKm   = parseFloat(modal.dataset.radiusKm) || 10;

  function haversineKm(lat1, lng1, lat2, lng2){
    const R = 6371;
    const toRad = d => d * Math.PI / 180;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat/2)**2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng/2)**2;
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
  }

  function geocode(address){
    if (!mbToken){
      return Promise.resolve(null);
    }
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json`
      + `?access_token=${encodeURIComponent(mbToken)}`
      + `&limit=1&proximity=${storeLng},${storeLat}`;
    return fetch(url).then(r => r.ok ? r.json() : Promise.reject(r.statusText))
      .then(data => {
        const f = data?.features?.[0];
        if (!f) return null;
        return { lng: f.center[0], lat: f.center[1], place: f.place_name };
      });
  }

  function openModal(deliveryCoords, addressText){
    modalAddr.textContent = addressText;
    // Mapbox Static Images: two pins, auto zoom-fit
    if (mbToken){
      const url = `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/`
        + `pin-l+10262c(${storeLng},${storeLat}),pin-l+D62A1E(${deliveryCoords.lng},${deliveryCoords.lat})`
        + `/auto/720x420@2x?access_token=${encodeURIComponent(mbToken)}&padding=80`;
      modalMap.innerHTML = `<img src="${url}" alt="Map of store and delivery location" />`;
    } else {
      modalMap.innerHTML = '';
    }
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal(){
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  modal.querySelector('[data-modal-close]')?.addEventListener('click', closeModal);
  modal.querySelector('[data-modal-change-address]')?.addEventListener('click', ()=>{
    closeModal();
    input?.focus();
    input?.select();
  });
  modal.querySelector('[data-modal-switch-pickup]')?.addEventListener('click', ()=>{
    setMode('pickup');
    closeModal();
    document.getElementById('order-hero-start')?.click();
  });
  modal.addEventListener('click', (e)=>{ if (e.target === modal) closeModal(); });

  /* ---------- Start Order ---------- */
  const startBtn = document.getElementById('order-hero-start');
  startBtn.addEventListener('click', ()=>{
    const mode = card.dataset.mode || 'pickup';
    const addr = (input?.value || '').trim();
    if (mode === 'delivery' && !addr){
      input?.focus();
      return;
    }
    if (!timeSel.value){
      timeSel.focus();
      return;
    }

    try {
      sessionStorage.setItem('terrace_order', JSON.stringify({
        mode, address: addr, date: dateSel.value, time: timeSel.value
      }));
    } catch(e) {}

    function proceed(){
      pushAttributes().finally(()=>{
        const target = document.getElementById('menu') || document.querySelector('.order-menu');
        target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // For pickup, skip validation
    if (mode === 'pickup'){
      proceed();
      return;
    }

    // For delivery, validate via Mapbox if token is configured
    if (!mbToken){
      // No token → skip validation, proceed (fail-open)
      proceed();
      return;
    }

    const originalLabel = startBtn.textContent;
    startBtn.classList.add('is-loading');
    startBtn.disabled = true;
    startBtn.textContent = 'Checking address…';

    geocode(addr).then(result => {
      startBtn.classList.remove('is-loading');
      startBtn.disabled = false;
      startBtn.textContent = originalLabel;

      if (!result){
        // Address not found
        modalAddr.textContent = addr;
        modal.querySelector('.order-hero__modal-title').textContent = "We couldn't find that address";
        modal.querySelector('.order-hero__modal-sub').textContent = "Double-check the spelling or try a postal code.";
        modalMap.innerHTML = '';
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        return;
      }

      const distance = haversineKm(storeLat, storeLng, result.lat, result.lng);
      // Persist coords + distance into cart attributes
      window.TerraceFulfillment = {
        ...window.TerraceFulfillment,
        'Delivery Address': result.place,
        'Delivery Latitude': result.lat.toFixed(6),
        'Delivery Longitude': result.lng.toFixed(6),
        'Delivery Distance (km)': distance.toFixed(2)
      };

      if (distance > radiusKm){
        // Out of area — open modal
        openModal(result, result.place);
        return;
      }

      // In area — proceed
      input.value = result.place; // use canonical address from Mapbox
      proceed();
    }).catch(err => {
      console.error('Geocoding failed', err);
      startBtn.classList.remove('is-loading');
      startBtn.disabled = false;
      startBtn.textContent = originalLabel;
      // Fail-open: proceed without validation if Mapbox call breaks
      proceed();
    });
  });

  // Also keep window.TerraceFulfillment fresh when user changes anything
  [dateSel, timeSel].forEach(el => el.addEventListener('change', ()=>{
    const mode = card.dataset.mode || 'pickup';
    const dateOpt = dateSel.options[dateSel.selectedIndex];
    const timeOpt = timeSel.options[timeSel.selectedIndex];
    window.TerraceFulfillment = {
      ...window.TerraceFulfillment,
      'Fulfillment': mode === 'pickup' ? 'Pickup' : 'Delivery',
      'Requested Date': dateOpt ? dateOpt.textContent : '',
      'Requested Time': timeOpt ? timeOpt.textContent : '',
      'Requested Date (ISO)': dateSel.value,
      'Requested Time (24h)': timeSel.value
    };
  }));
  segBtns.forEach(b => b.addEventListener('click', ()=>{
    window.TerraceFulfillment = {
      ...window.TerraceFulfillment,
      'Fulfillment': b.dataset.mode === 'pickup' ? 'Pickup' : 'Delivery',
      'Pickup Address': b.dataset.mode === 'pickup' ? (hero.querySelector('[data-address]')?.textContent || '').trim() : '',
      'Delivery Address': b.dataset.mode === 'delivery' ? (input?.value || '').trim() : ''
    };
  }));
  input?.addEventListener('input', ()=>{
    window.TerraceFulfillment = {
      ...window.TerraceFulfillment,
      'Delivery Address': (input.value || '').trim()
    };
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-menu"] && !Shopify.designMode) return;
  try {
    
(function(){
  const nav = document.querySelector('.order-menu__catnav');
  const links = document.querySelectorAll('.order-menu__catnav a');
  const groups = document.querySelectorAll('.order-menu__group');

  // Edge fades: only show a fade on sides that have more pills hidden
  function updateFades(){
    if (!nav) return;
    const max = nav.scrollWidth - nav.clientWidth - 1;
    nav.classList.toggle('fade-l', nav.scrollLeft > 2);
    nav.classList.toggle('fade-r', nav.scrollLeft < max);
  }
  if (nav){
    nav.addEventListener('scroll', updateFades, { passive: true });
    window.addEventListener('resize', updateFades);
    updateFades();
  }

  if (!('IntersectionObserver' in window)) return;
  let activeId = null;
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(en=>{
      if (en.isIntersecting){
        const id = en.target.id;
        links.forEach(l=>l.classList.toggle('on', l.getAttribute('href')==='#'+id));
        if (nav && id !== activeId){
          activeId = id;
          const active = nav.querySelector('a[href="#'+id+'"]');
          if (active){
            nav.scrollTo({ left: active.offsetLeft - nav.clientWidth/2 + active.offsetWidth/2, behavior: 'smooth' });
          }
        }
      }
    });
  }, { rootMargin:'-40% 0px -55% 0px' });
  groups.forEach(g=>io.observe(g));
})();

  } catch(e) { console.error(e); }
})();
})();
